import { Modal } from '@arco-design/web-vue';
import useI18n from "@/i18n/index.js";
const { t } = useI18n.global;

if (process.env.NODE_ENV === "production") {
    let lastSrcs
    const scriptReg = /<script.*?src="(.*?)"/g;
    async function getScripts() {
        const html = await fetch('/?timestep=' + Date.now()).then((res) => res.text());
        scriptReg.lastIndex = 0;
        const result = [];
        let match;

        while ((match = scriptReg.exec(html))) {
            result.push(match[1]);
        }
        return result;
    }

    async function needUpdate() {
        const newScripts = await getScripts();
        if (!lastSrcs) {
            lastSrcs = newScripts;
            return false;
        }
        let result = false;
        if (lastSrcs.length !== newScripts.length) {
            result = true;
        }
        for (let i = 0; i < lastSrcs.length; i++) {
            if (lastSrcs[i] !== newScripts[i]) {
                result = true;
                break;
            }
        }
        lastSrcs = newScripts;
        return result;
    }

    const timeData = 2000;
    function autRef() {
        setTimeout(async () => {
            const willUp = await needUpdate();
            if (willUp) {
                Modal.success({
                    title: t('autoUpdate.title'),
                    content: t('autoUpdate.content'),
                    hideCancel: true,
                    escToClose: false,
                    closable: false,
                    maskClosable: false,
                    okText: t('common.ok'),
                    modalStyle: {
                        textAlign: 'center'
                    },
                    onOk: () => {
                        location.reload();
                    },
                });
            };
            autRef();
        }, timeData)
    }
    autRef();
}